const AUTH_MODAL_EVENT = 'auth-modal:open';

/**
 * type: 'unauthenticated' | 'expired'
 */
export function openAuthModalEvent(type = 'unauthenticated') {
  window.dispatchEvent(new CustomEvent(AUTH_MODAL_EVENT, { detail: { type } }));
}

export function listenAuthModalEvent(callback) {
  const handler = (e) => callback(e.detail);
  window.addEventListener(AUTH_MODAL_EVENT, handler);
  return () => window.removeEventListener(AUTH_MODAL_EVENT, handler);
}
